import { configureStore } from "@reduxjs/toolkit";

import appReducer from "./reducer.ts";

const store = configureStore({
  reducer: {
    ar: appReducer
  },
  middleware: (getDefaultMiddleware) => (getDefaultMiddleware({
    serializableCheck: false /* {
      ignoredActions: ["ar/changeAppState", "ar/setGlobalMask"],
      ignoredPaths: [(/^ar\.uiState\./igm)]
    } */
  }))
});

// @ts-ignore
export default store;

// Infer the 'RootState' and 'AppDispatch' types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {ar: appReducer, ...}
export type AppDispatch = typeof store.dispatch;
